const initialState = {
  data: [],
};
  
const udzialyKontaUReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_UDZIALY_KONTA_U':
      return { ...state, data: action.payload };
    default:
      return state;
  }
};

export default udzialyKontaUReducer;